// Importamos Svg e Path da biblioteca correta
import { Svg, Path } from '@react-pdf/renderer';

// --- DEFINIÇÃO DOS ÍCONES CONVERTIDOS ---

const LinkedInIcon = ({ style }) => (
    <Svg viewBox="0 0 24 24">
        <Path
            fill={style.color || 'black'}
            d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
        />
    </Svg>
);

const GithubIcon = ({ style }) => (
    <Svg viewBox="0 0 24 24">
        <Path
            fill={style.color || 'black'}
            d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
        />
    </Svg>
);

const InstagramIcon = ({ style }) => (
    <Svg viewBox="0 0 448 512">
        <Path 
            fill={style.color || 'black'} 
            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9 26.3 26.2 58 34.4 93.9 36.2 37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
        />
    </Svg>
);

const XIcon = ({ style }) => (
    <Svg viewBox="0 0 512 512">
        <Path 
            fill={style.color || 'black'} 
            d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
        />
    </Svg>
);

const ThreadsIcon = ({ style }) => ( // Corrigido de "Threds" para "Threads"
    <Svg viewBox="0 0 448 512">
        <Path 
            fill={style.color || 'black'} 
            d="M331.5 212.5c0-18.3-14.8-33.1-33.1-33.1s-33.1 14.8-33.1 33.1 14.8 33.1 33.1 33.1 33.1-14.8 33.1-33.1m-117.8-33.1c-18.3 0-33.1 14.8-33.1 33.1s14.8 33.1 33.1 33.1 33.1-14.8 33.1-33.1-14.8-33.1-33.1-33.1m-189.6 13.9C6.8 205.1 0 223.4 0 243.2 0 266 10.7 286.1 27.5 299.8L120 361.3V464h64v-96.3l9.8-6.1c-1.3-.5-2.6-1.1-3.9-1.7-33.1-17.3-51-51.4-44.1-85.4 7-34.3 39.8-59.8 74.8-59.8 19 0 36.3 7.3 49.3 19.3 13.5 12.5 20.9 29.5 20.9 47.7 0 10.2-2.1 19.8-6 28.5-3.8 8.5-8.9 16.1-15.1 22.6-6.2 6.5-13.4 12-21.3 16.4l-.3.2-12.7 6.7c-3.1 1.6-6.3 3.3-9.5 5-29.4 15.3-46.7 45.4-42.3 76.5 4.6 32.5 32.3 56.6 64.9 56.6 21.4 0 40.4-10.4 52.8-27.4l20.1 12.4c-17.6 28.6-49.8 47.5-86.8 47.5-52.5 0-96.1-41.9-99.8-95.2-.6-8.8.8-17.5 3.6-25.7l-92.4-57.2C10.7 286.1 0 266 0 243.2c0-19.8 6.8-38.1 18.5-51.8C30.2 178 47.9 168 66.9 168h21.9c-2.4-7.5-3.8-15.4-3.8-23.7 0-42.3 29.5-77.9 69.3-86.5 3.5-.7 7-.1 10.3 1.8l114.3 64.1c11.7 6.5 19.3 18.4 19.3 31.5 0 10.2-4.1 19.6-11 26.5l-20.1-12.4c6-8.9 9.3-19.4 9.3-30.5 0-5.3-1.6-10.4-4.5-14.7L167.3 52.1c-22.3 9.4-37.9 31.4-37.9 56.5 0 13.4 4.1 25.7 11.2 35.8H66.9c-19 0-36.7 10-48.4 23.7z"
        />
    </Svg>
);

const FacebookIcon = ({ style }) => (
    <Svg viewBox="0 0 512 512">
        <Path 
            fill={style.color || 'black'} 
            d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
        />
    </Svg>
);


// --- Componente Seletor de Ícone ---
const Icon = ({ name, style }) => {
    switch (name.toLowerCase()) {
        case 'linkedin':
            return <LinkedInIcon style={style}/>;
        case 'github':
            return <GithubIcon style={style}/>;
        case 'instagram':
            return <InstagramIcon style={style}/>;
        case 'x':
            return <XIcon style={style}/>;
        case 'threads':
            return <ThreadsIcon style={style}/>; // Corrigido
        case 'facebook':
            return <FacebookIcon style={style}/>;
        default:
            return null;
    }
};

export default Icon;